import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, Fragment as _Fragment } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "dc-modal__overlay"
}, null, -1);
const _hoisted_2 = {
  key: 0,
  class: "dc-modal__header"
};
const _hoisted_3 = {
  key: 1,
  class: "dc-modal__footer"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3 2H45C45.5523 2 46 2.44772 46 3V45C46 45.5523 45.5523 46 45 46H3C2.44772 46 2 45.5523 2 45V3C2 2.44772 2.44772 2 3 2ZM0 3C0 1.34315 1.34315 0 3 0H45C46.6569 0 48 1.34315 48 3V45C48 46.6569 46.6569 48 45 48H3C1.34315 48 0 46.6569 0 45V3ZM29.1199 31.2423L23.563 25.6854L18.0061 31.2423L15.8848 29.121L21.4417 23.5641L15.8848 18.0072L18.0061 15.8859L23.563 21.4428L29.1199 15.8859L31.2412 18.0072L25.6843 23.5641L31.2412 29.121L29.1199 31.2423Z",
  fill: "currentColor"
})], -1);
const _hoisted_5 = [_hoisted_4];
import { computed, ref, watch, onMounted } from 'vue';
import { trapFocusToModal } from '@/utils/accessibility';
export default {
  __name: 'DcModal',
  props: {
    children: {
      type: Array,
      default() {
        return [];
      }
    },
    popup: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: 'center'
    },
    size: {
      type: String,
      default: 'basic'
    },
    triggerLabel: {
      type: String,
      default: ''
    },
    triggerStyle: {
      type: String,
      default: 'button'
    },
    cssClasses: {
      type: String
    }
  },
  emits: ['modalClose', 'modalOpen'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const modalSizeClasses = {
      basic: 'basic',
      large: 'large',
      full: 'full'
    };
    const isOpen = ref(true);
    const modal = ref(null);
    const combinedClasses = computed(() => {
      if (isOpen.value === true) {
        return props.cssClasses ? props.cssClasses + ' active' : 'active';
      }
      return props.cssClasses ? props.cssClasses : '';
    });
    const closeModal = () => {
      isOpen.value = false;
      emit('modalClose', modal.value);
    };
    const openModal = () => {
      isOpen.value = true;
      emit('modalOpen', modal.value);
      handleTrapping();
    };
    const handleTrapping = () => {
      modal.value?.querySelector('input:not([type="hidden"]), button, a, textarea')?.focus();
      modal.value?.addEventListener('keydown', element => {
        trapFocusToModal(element, modal.value);
      });
    };
    watch(isOpen, (newValue, oldValue) => {
      if (newValue === true) {
        handleTrapping();
      }
    });
    onMounted(() => handleTrapping());
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [__props.triggerLabel ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        onClick: openModal,
        class: _normalizeClass(__props.triggerStyle)
      }, _toDisplayString(__props.triggerLabel), 3)) : _createCommentVNode("", true), isOpen.value ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["dc-modal", combinedClasses.value]),
        ref_key: "modal",
        ref: modal
      }, [_hoisted_1, _createElementVNode("div", {
        tabindex: -1,
        class: _normalizeClass(["dc-modal__window", `${modalSizeClasses[__props.size]}`])
      }, [_ctx.$slots.header ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_renderSlot(_ctx.$slots, "header")])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["dc-modal__body", {
          'tw-mb-0': !_ctx.$slots.footer
        }])
      }, [_renderSlot(_ctx.$slots, "body")], 2), _ctx.$slots.footer ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_renderSlot(_ctx.$slots, "footer")])) : _createCommentVNode("", true), _createElementVNode("button", {
        onClick: closeModal,
        type: "button",
        class: "dc-modal__close",
        "aria-label": "Close Modal"
      }, _hoisted_5)], 2)], 2)) : _createCommentVNode("", true)], 64);
    };
  }
};